/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamAdmPostovniSluzbaProZasilky extends GContentBase<SeznamAdmPostovniSluzbaProZasilkyObj> {
        private seznamObj: SeznamAdmPostovniSluzbaProZasilkyObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamAdmPostovniSluzbaProZasilkyObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamAdmPostovniSluzbaProZasilky",
                contentCaption: "jres:33000179", //RC 33000179 : Poštovní služby
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{post_sluzba}"
                },
                gridSettings: {
                    columnOrder: "post_sluzba,post_sluzba_zkr,post_sluzba_txt,post_sluzba_poz,zmenu_prov_txt,dat_zmena,priz_doruc_txt,filtr_format"
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }
    }

    export class SeznamAdmPostovniSluzbaProZasilkyObj extends GAdmSeznamBase {
        create() {

        }

        openDetail(data: any, isNew: boolean) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailAdmPostovniSluzbaProZasilky", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid)
            }], {
                ID: "DetailAdmPostovniSluzbaProZasilky",
                newRecord: isNew,
                post_sluzba: isNew == true ? null : data.post_sluzba
            })
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*"])
        }

        createFilterForm() {
            
        }

        userhardDefaultFilter(hardFilter: any): any {
            return hardFilter;
        }

        collectData(data: any) {

        }

        applydata(filterData: any) {
            this.cnt.isl.AdmPostovniSluzbaProZasilky.list({ filters: filterData }).getView().done((data) => {
                this.setOmezeniEditaceComlumn(data);
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        private setOmezeniEditaceComlumn(data: Data.View) {
            data.process({
                ac: new Gordic.Data.ComputedFieldsProcessor(
                    (rows) => {
                        rows.forEach((row) => {
                            if (row.data.post_sluzba < 1500)
                                row.data.zamek = GAdmGlobals.ZamekEnum.uzamceno
                            else
                                row.data.zamek = GAdmGlobals.ZamekEnum.neuzamceno;
                        })
                    }
                )
            })
        }

        selectionGridAct(objArr: IGGridSelection<any>) {
            this.cnt.actions.actOpenSslDenik?.update({ enabled: objArr.count > 0 })
        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: "{0}".format(data.post_sluzba),
                nazev: ""
            }
        }
    }
}